import thunk from 'redux-thunk';
import * as types from './actionTypes';
import { handleError } from '../errors/handleError';
import * as projectConfigApi from '../apis/ProjectConfigApi';

export function errorHandler(dispatch, error, type) {
    const errorMessage = handleError(error);

    dispatch({
        type,
        error: errorMessage,
    });
}

export function checkProjectConfig(projectId) {
    return function (dispatch) {
        dispatch({
            type: types.CHECK_PROJECT_CONFIG_PENDING,
        });
        return projectConfigApi.checkProjectConfig(projectId)
            .then((response) => {
                dispatch({
                    type: types.CHECK_PROJECT_CONFIG_SUCCESS,
                    payload: response.data.data,
                });
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.CHECK_PROJECT_CONFIG_FAILED);
            });
    };
}
